import Swiper from "swiper";
import { Navigation, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

const initQuotesSlider = () => {
  const partners = document.querySelectorAll(".news-slider-swiper");

  partners.forEach((partner) => {
    new Swiper(partner, {
      modules: [Navigation, A11y],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 32,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      a11y: {
        enabled: true,
        scrollOnFocus: false,
      },
      breakpoints: {
        518: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
};

window.addEventListener("load", () => {
  initQuotesSlider();
});
